export default __webpack_public_path__ + "static/media/III-2020.bc42183d.pdf";